import { AgGridAngular } from 'ag-grid-angular';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { cloneDeep, debounce } from 'lodash';
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ViewChild } from '@angular/core';
import { CvAngularLoadingOverlayComponent } from 'src/app/reusables/ag-grid-components/cv-angular-loading-overlay/cv-angular-loading-overlay.component';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CvConnect3AllResultRenderComponent } from '../cv-connect3-all-result-render/cv-connect3-all-result-render.component';
import { GameParticipant } from 'src/AngularJS/Goals/Gamification/Models/game-history';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { GameType } from 'src/app/gamification/command-center/models/games.model';
import { GenericMetricFormatterPipe } from 'src/app/reusables/pipes/generic-metric-formatter.pipe';
import {
  getQualifier,
  isConnect3,
  isConnectAll,
  getJoinStatusIcon,
  getCenterClass,
  getPassedStatusIcon,
  getHeaderClass,
  getCellClass,
  getStatusIcon,
  getBadgeSize,
  getHeaderCenterClass,
  getClassIfNotPinned,
  getRowPinnedClass,
  formatCoin,
  formatPaymentInfoValue,
  connect3AndLevelGamesConnectStatusClass
} from 'src/app/gamification/command-center/models/games-player-breakdown';
import { ColumnGroupOpenedEvent, GridApi, GridOptions, GridReadyEvent, GridSizeChangedEvent, RowSelectedEvent } from 'ag-grid-community';
import { IHGameStandardize } from 'src/app/gamification/command-center/models/games-parameter.model';
import { MarketplaceOrderStatus } from 'src/app/gamification/command-center/models/marketplace-order.model';

type ProductState = {
  [key in MarketplaceOrderStatus]: string;
}
const PRODUCT_STATES: ProductState = {  
  [MarketplaceOrderStatus.InTransit]: "In_Transit",
  [MarketplaceOrderStatus.ReadyForPickup]: "Ready_for_Pickup",
  [MarketplaceOrderStatus.Complete]: "Complete",
  [MarketplaceOrderStatus.Shipped]: "Shipped",
  [MarketplaceOrderStatus.Cancelled]: "Cancelled", 
  [MarketplaceOrderStatus.Created]:"Processing",
  [MarketplaceOrderStatus.Processing]: "Processing",
};

const validOrderStatus = [MarketplaceOrderStatus.Created, MarketplaceOrderStatus.Processing, MarketplaceOrderStatus.ReadyForPickup];

@Component({
  selector: 'cv-games-history-table',
  templateUrl: './games-history-table.component.html',
  styleUrls: ['./games-history-table.component.scss', '../../games-add-edit-components/games-configure-components/configure-eligibility-brackets/configure-eligibility-brackets.component.scss']
})

export class GamesHistoryTableComponent implements OnInit {
  @Input() participants: any[];
  @Input() enableSelection: boolean;
  @Input() selectAll: boolean;
  @Input() reversion: boolean;
  @Input() hGame: IHGameStandardize;
  @Output() selectedData: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() selectedColumns: EventEmitter<any[]> = new EventEmitter();
  @Output() sortModel: EventEmitter<any[]> = new EventEmitter();
  @Output() totalRow: EventEmitter<any[]> = new EventEmitter();
  @Output() participantsSorted: EventEmitter<GameParticipant[]> = new EventEmitter();
  @ViewChild('gamesHistoryTableGrid') agGrid: AgGridAngular;

  gs = null;
  metricFields = null;
  participant = null;
  metric = null;
  qualifier = null;
  results = null;
  rewards = null;
  selectedRows: any[] = [];
  grid: GridOptions;
  revertedCoins: number = 0;
  revertedXP: number = 0;
  prevReversionValue: boolean;

  // Bracket view
  isExpandedView: boolean = false;
  currentParticipant = null;

  gridApi: GridApi;
  private previousGame: number = -1;

  constructor(
    private gamesService: GamesService,
    private metricFormatPipe: GenericMetricFormatterPipe,
    private agGridHelperService: AgGridHelperService,
    public cvConfigurationService: CvConfigurationService
  ) { 
    this.gs = this.gamesService.data;
    $(document).on('cancelRevertSelection', this.cancelRowSelection);;
  }

  ngOnInit(): void {
    this.setupGrid();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.agGrid && this.agGrid.api) {
      if (changes.participants != undefined && changes.participants.currentValue != null) {
        this.agGrid?.api?.setGridOption('columnDefs', this.getColDefs());
        this.agGrid.api.setGridOption('rowData', changes.participants.currentValue);
        this.agGrid.api.autoSizeAllColumns();

        const pinnedData = this.createPinnedData(changes.participants.currentValue);
        this.agGrid?.api?.setGridOption('pinnedBottomRowData', pinnedData);

        /// Ag Grid 30.0.0 switch from setSortModel to applyColumnState through the columnApi
        ///this.agGrid?.api?.setSortModel([{ colId: 'ParticipantName', sort: 'desc' }]);
        this.agGrid?.api?.applyColumnState({
          state: [{ colId: 'ParticipantName', sort: 'desc' }]
        });
        //this.agGrid.columnApi.autoSizeAllColumns();
        this.agGrid?.api?.sizeColumnsToFit();
        this.agGrid?.api?.refreshCells({ force: true });

        this.agGrid?.api?.hideOverlay();
        if (this.participants.length > 0) {
          this.agGrid?.api?.refreshHeader();
        } else {
          this.agGrid?.api?.showNoRowsOverlay();
        }
      } else if (changes.enableSelection != undefined && changes.enableSelection.currentValue != null) {
        this.agGrid?.api?.setGridOption('columnDefs', []);
        this.agGrid?.api?.setGridOption('columnDefs', this.getColDefs());

        if (!changes.enableSelection.currentValue) {
          this.cancelRowSelection();
        }

        this.agGrid?.columnApi?.autoSizeAllColumns();
        this.agGrid?.api?.sizeColumnsToFit();
      } else if (changes.selectAll != undefined) {
        if (changes.selectAll.currentValue) {
          this.agGrid?.api?.selectAll();
        } else {
          this.cancelRowSelection();
        }
      } else if(changes.reversion != undefined && changes.reversion.currentValue != null) {
        if (changes.reversion.currentValue) {
            this.selectedData.emit(this.selectedRows);
        }

      } else {
        this.agGrid.api.showLoadingOverlay();
      }

      this.selectedColumns.emit(this.agGrid.api.getColumnState());
      const pinnedBottomRow = this.agGrid.api.getPinnedBottomRow(0);
      if (pinnedBottomRow && pinnedBottomRow.data) {
        this.totalRow.emit(this.agGrid.api.getPinnedBottomRow(0).data);
      }

      if (changes.hGame && changes.hGame.previousValue && changes.hGame.previousValue.RuleID != null) {
        this.previousGame = changes.hGame.previousValue.RuleID;
      }
    }
  }

  private createPinnedData(participants: any[]): any[] {
    const sumPlayers = participants.reduce((sum, current) => sum + 1, 0);
    const sumCoins = participants.filter((a: any) => { return a.calculatedCoins >= 0; }).reduce((sum, current) => sum + current.calculatedCoins, 0);
    const sumXP = participants.filter((a: any) => { return a.calculatedXP >= 0; }).reduce((sum, current) => sum + current.calculatedXP, 0);
    const sumBadges = participants.reduce((sum, current) => sum + current.badges.length, 0);
    const sumCustomRewards = participants.filter((a: { custom?: string, isReverted: boolean }) => a.custom?.length > 0 && !a.isReverted).length;
    const sumRevertCustomRewards = participants.filter((a: { custom?: string, isReverted: boolean }) => a.custom?.length > 0 && a.isReverted).length;
    const revertedCustomRewards = sumRevertCustomRewards > 0 ? `(-${sumRevertCustomRewards})` : '';

    this.revertedCoins = participants.filter((a: any) => { return a.calculatedCoins < 0; }).reduce((sum, current) => sum + (current.calculatedCoins), 0);
    this.revertedXP = participants.filter((a: any) => { return a.calculatedXP < 0; }).reduce((sum, current) => sum + (current.calculatedXP), 0);

    return [{
      participants: this.gamesService.getGamesHistoryMessages('Total_Players', 'Total Players') + ": " + sumPlayers.toLocaleString(CVCultureName),
      calculatedCoins: sumCoins.toLocaleString(CVCultureName),
      calculatedXP: sumXP,
      badges: sumBadges,
      custom: `${sumCustomRewards.toLocaleString(CVCultureName)} ${revertedCustomRewards} ${this.gamesService.getGamesHistoryMessages('Custom_Reward', 'Custom Reward')}`,
    }];
  }

  setupGrid(){
    //Create grid options
    this.grid = {
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        width: 200,
      },

      accentedSort: true,
      animateRows: true,
      masterDetail: true,
      suppressCellFocus: true,
      suppressDragLeaveHidesColumns: true,
      suppressRowTransform: true,
      rowSelection: 'multiple',
      columnDefs: this.getColDefs(),
      rowHeight: this.cvConfigurationService.isCxOne ? 36 : undefined,
      headerHeight: this.cvConfigurationService.isCxOne ? 42 : undefined,
      overlayNoRowsTemplate: this.cvConfigurationService.isCxOne
        ? `
            <div class="error-container" style="padding-top: 48px;">
                <svg class="mb-2" style="height: 108px; width: 240px;">
                    <use href="../App_Themes/CXone/icons/cxone-no-items.svg#cxone-no-items"></use>
                </svg>
                <p class="player-breakdown__grid-empty-state">
                    ${this.gamesService.getGamesHistoryMessages('No_Items_Created_Yet', 'No items created yet')}
                </p>
            </div>`
        : undefined,

      isRowSelectable: (rowNode) => {
        if(!rowNode || !rowNode.data) return false;
        const hasPrize = (rowNode.data.calculatedCoins > 0 || rowNode.data.calculatedXP > 0);
        const hasValidStatus = rowNode.data.custom?.length > 0 && rowNode.data.productState != undefined && validOrderStatus.includes(rowNode.data.productState);
        // Row is selectable if is not reverted and if has a prize or if is a custom prize with a valid order status (processing, ready for pickup)
        return !rowNode.data.isReverted && (hasPrize || hasValidStatus);
      },

      getRowStyle: (params) => {
        if (params.node.rowPinned) {
          return { 'font-weight': 'bold' }
        }
      },

      getRowClass: (params) => {
        return getRowPinnedClass(this.cvConfigurationService.isCxOne, params.node.rowPinned);
      },

       // Sidebar will be included in the full version
      sideBar: this.cvConfigurationService.isCxOne ? false : {
        toolPanels: [{
          id: 'columns',
          labelDefault: this.gamesService.getGamesHistoryMessages('Columns', 'Columns'),
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
        }],
        defaultToolPanel: ''
      },

      components: {
        cvAngularLoadingComponent: CvAngularLoadingOverlayComponent,
      },

      rowData: null,
      loadingOverlayComponent: 'cvAngularLoadingComponent',
      getLocaleText: this.agGridHelperService.getLocaleText,

      getRowId: (param: any) => {
        if (param.data && param.data.participant) { 
          return String(param.data.participant.LoginID);
        }
        return null;
      },

      onGridReady: (e: GridReadyEvent) => {

        this.gridApi = e.api;

        if (this.participants) {
          this.setPinnedData(this.participants);
        } else {
          this.setPinnedData([]);
        }

        if (this.participants && this.participants.length > 0) {
          e.api.setGridOption('rowData', this.participants);
          e.api.autoSizeAllColumns();

          if (this.participants.length > 0) {
            e.api.hideOverlay();
          } else {
            this.grid.noRowsOverlayComponent = null;
            e.api.showNoRowsOverlay();
          }
        }
        if (!this.gs.isLoading && (!this.participants || this.participants.length == 0)) {
          if ((!this.gs.selectedInterval || this.gs.selectedInterval.length == 0) || (this.gs.selectedInterval || this.gs.selectedInterval.length > 0)) {
            this.agGrid?.api?.hideOverlay();
            this.agGrid?.api?.showNoRowsOverlay();
          }
        }
        if (this.agGrid?.columnApi) {
          this.updateSelectedColumns();
        }
        if (this.agGrid?.api && this.agGrid.api?.getPinnedBottomRow(0) && this.agGrid.api.getPinnedBottomRow(0).data) {
          this.totalRow.emit(this.agGrid.api.getPinnedBottomRow(0).data);
        }
      },

      onGridSizeChanged: (e: GridSizeChangedEvent) => {
        this.handleResizeOnGameOrGroupChange(e);
      },

      onRowSelected: (e: RowSelectedEvent) => {
        this.updateSelectedData(e);
      },
      
      onColumnMoved: () => {
        this.updateSelectedColumns();
      },

      onColumnVisible: () => {
          this.updateSelectedColumns();
      },

      onSortChanged: () => {
          this.updateSelectedColumns();
      },

      postSortRows: (X) => {
        let selectedRowNodesWithSort = [];
        this.agGrid.api.forEachNodeAfterFilterAndSort((node) => {
          selectedRowNodesWithSort.push(node.data);
        });

        this.participantsSorted.emit(cloneDeep(selectedRowNodesWithSort));
      },

      onColumnGroupOpened: (event: ColumnGroupOpenedEvent) => {
        const isExpanded = event.columnGroups[0]?.isExpanded();
        if (isExpanded) return; // Only resize when column group is closed
        window.requestAnimationFrame(() => {
          this.resizeColumns(event);
        });
      }
    }
  }
  
  updateSelectedData(e: RowSelectedEvent): void {
    if (e.node.isSelected()) {
      this.selectedRows.push(e.node.data);
    } else {
      var index = this.selectedRows.indexOf(e.node.data);
      if (index > -1) {
        this.selectedRows.splice(index, 1);
      }
    }
  }

  updateSelectedColumns(): void {
    this.selectedColumns.emit(this.agGrid.columnApi.getColumnState());
  }

  setNameColumnValue(params: any): any {
    if (params.data && typeof params.data === 'object' && !params.data.hasOwnProperty('participants')) {
      let $productContainer = $('<div>').addClass('d-flex');

      //Image profile
      let imageId = params.data && params.data.ImageID > 0 ? params.data.ImageID : "";
      let $img = null;
      const hasInvalidStatus = params.data.custom?.length > 0 && params.data?.productState != undefined && !validOrderStatus.includes(params.data.productState);

      if (!this.cvConfigurationService.isCxOne) {
        //If the revert controls are enabled and the record payment can't be reverted, a left magin and padding are included to align this record with the others that have the checkbox input
        if (this.enableSelection && (params.data.isReverted || (params.data.calculatedCoins <= 0 && params.data.calculatedXP <= 0 && params.data.custom?.length <= 0) || hasInvalidStatus))
          $img = $('<img>').addClass('mr-2 ml-4 pl-1').css({ 'height': 25, 'border-radius': '50%' }).appendTo($productContainer);
        else
          $img = $('<img>').addClass('mr-2').css({ 'height': 25, 'border-radius': '50%' }).appendTo($productContainer);

        $img.attr('src', `${_BaseURI}/Admin/ImageResizer.aspx?imgid=${imageId}&w=auto&h=25`);
        $img.on('error', () => $img.attr('src', `${_BaseURI}/Admin/ImageResizer.aspx?imgid=&w=auto&h=26`));
      }

      // Product name
      $('<span>').text(params.value).appendTo($productContainer)

      return $productContainer[0];
    } else {
        return params.data.participants;
    }
  }

  cancelRowSelection(): void {
    if (this.grid != null) {
      this.agGrid?.api?.deselectAll();
      this.selectedRows = [];
    }
  }

  getColDefs(): any {
    let resultsArray = [];

    let participant = {
      headerName: this.gamesService.getGamesHistoryMessages('Player', 'Player'),
      headerClass: params => {
        return [getHeaderClass(this.cvConfigurationService.isCxOne), this.cvConfigurationService.isCxOne ? 'player-breakdown__player-header' : '']
      },
      children: [{
        field: 'participant.LoginName',
        minWidth: 175,
        headerName: this.gamesService.getGamesHistoryMessages('Name', 'Name'),
        headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
        cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCellClass(this.cvConfigurationService.isCxOne)),
        filter: 'agTextColumnFilter',
        checkboxSelection: this.enableSelection,
        cellRenderer: (params) => { return this.setNameColumnValue(params); }
      }]
    }
    resultsArray.push(participant);

    let joined = null;
    if (this.gs.selectedGame && this.gs.selectedGame[0] && this.gs.selectedGame[0].GameType != 10) {
      joined = {
        field: 'participant.AlreadyJoined',
        headerName: this.gamesService.getGamesHistoryMessages('Player_Joined', 'Joined?'),
        headerClass: () => [getHeaderClass(this.cvConfigurationService.isCxOne), getHeaderCenterClass(this.cvConfigurationService.isCxOne)],
        cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCenterClass(this.cvConfigurationService.isCxOne)),
        cellRenderer: (params) => {
          if (params.value === undefined || params.value === null)
            return '';

          const approve = getJoinStatusIcon(this.gs.selectedGame, params.value, this.cvConfigurationService.isCxOne);

          return approve;
        },
        width: this.cvConfigurationService.isCxOne ? 100 : undefined,
      };
      resultsArray.push(joined);
    }
      
    let metric = null;
    if (this.hGame && (isConnect3(this.hGame.GameType) || isConnectAll(this.hGame.GameType))) {
      const allMetrics = this.hGame.Connect3Definition;
      const connect3Metrics = [];
      for (let i = 0; i < allMetrics.length; i++) {
        const metric = allMetrics[i];
        const metricTemp = {
          headerClass: () => [getHeaderClass(this.cvConfigurationService.isCxOne)],
          headerValueGetter: params => {
            if (metric.MetricID != -1) {
              let metricString = metric.MetricDetail?.Abbrev || '';
              metricString += metric.MetricDetail?.DefaultMetricDirection === 0 ? "<" : ">";
              metricString += this.metricFormatPipe.transform(metric.LeftNumber, metric.MetricDetail?.ConversionType?.toString());
              return metricString;
            } else if (metric.MetricID == -1) {
              return this.gamesService.getLocalizedMessage(metric.MetricDetail?.Abbrev, 'Free Space');
            }
            return '--';
          },
          cellRenderer: (params) => {
            const platform = this.cvConfigurationService.isCxOne ? 'CXOne' : 'PM';
            const metricsValues = params.data?.metricsValues;
            if (!(metricsValues)) {
              return params.node.rowPinned && this.cvConfigurationService.isCxOne ? '' : '---';
            }
            const metricValue = metricsValues.find(m => m.MetricID === metric.MetricID);
            if (metricValue && metric.MetricID != -1) {
              const condition = metric.MetricDetail?.DefaultMetricDirection === 0 ? metricValue?.MetricValue <= metric.LeftNumber : metricValue?.MetricValue >= metric.LeftNumber;
              const mark = condition ? getStatusIcon('checkMark', platform, 'ml-3') : getStatusIcon('close', platform, 'ml-3');
              return metricValue ? `${metricValue.MetricDisplayValue} ${mark}` : '';
            } else if (metric.MetricID == -1) {
              return getStatusIcon('checkMark', platform, 'ml-3');
            } else {
              return params.node.rowPinned && this.cvConfigurationService.isCxOne ? '' : '---';
            }
          },
          columnGroupShow: i != 0 ? 'open': false,
        }
        connect3Metrics.push(metricTemp);
      }

      metric = {
        headerName: this.gamesService.getGamesHistoryMessages('Metric_Total', 'Metric Total'),
        groupId: 'metricTotalsGroup',
        headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
        children: connect3Metrics,
      };
    } else if (this.hGame) {
      const metricDetail = this.hGame.metricDefinition;

      const nonQualifierMetric = this.hGame.HistorySelectedMetrics?.find(m => !m.IsQualifier);
      const nonQualifierMetricID = nonQualifierMetric?.MetricID;

      metric = {
        headerName: this.gamesService.getGamesHistoryMessages('Metric_Total', 'Metric Total'),
        headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
        children: [{
          field: 'metric',
          headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
          cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCellClass(this.cvConfigurationService.isCxOne)),
          headerValueGetter: params => {
            if (nonQualifierMetricID && this.hGame.HMetricDetails && this.cvConfigurationService.isCxOne) {
                const metricDetail = this.hGame.HMetricDetails[nonQualifierMetricID];
                return metricDetail?.Abbrev ?? '--';
            }else if (metricDetail) {
              return metricDetail.MetricDetail?.Name;
            }
            return '--';
          },
          cellRenderer: (params) => {
            if (this.cvConfigurationService.isCxOne && nonQualifierMetricID) {
                const metricsValues = params.data.metricsValues || [];
                const metricObj = metricsValues.find(m => m.MetricID === nonQualifierMetricID);
                return metricObj ? metricObj.MetricDisplayValue : '--';
            }
            return params.value ?? '--';
          },
        }]  
      };
    }

    if (metric) resultsArray.push(metric);

    if (this.hGame && getQualifier(this.hGame)) {
      const qualifierMetric = getQualifier(this.hGame);

      let qualifier = {
        headerName: this.gamesService.getGamesHistoryMessages('Qualifier_Metric', 'Qualifier Metric'),
        headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
        children: [{
          field: 'qualifier',
          headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
          cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCellClass(this.cvConfigurationService.isCxOne)),
          headerValueGetter: params => {
            if (qualifierMetric) {
              return qualifierMetric.MetricDetail ? qualifierMetric.MetricDetail.Name : this.gamesService.getGamesHistoryMessages('None', 'None');
            }
              return '--';
          },
          cellRenderer: (params) => {
              if (params.value != undefined && params.value != null) {
                return params.value;
              }
            },
        },
        {
          field: 'passed',
          headerName: this.gamesService.getGamesHistoryMessages('Player_Passed', 'Passed?'),
          headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
          cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCenterClass(this.cvConfigurationService.isCxOne)),
          cellRenderer: (params) => {
            if (params.value === undefined)
              return '';
        
            const approve = getPassedStatusIcon(qualifierMetric, params.value, this.cvConfigurationService.isCxOne);
            return approve;
          },
          filterParams: {
            cellRenderer: (params) => {
              if (params.value === undefined)
                return '';
        
              const approve = getPassedStatusIcon(qualifierMetric, JSON.parse(params.value.toLowerCase()), this.cvConfigurationService.isCxOne);
              return approve;
            }
          }
        }]
      };
      if (qualifierMetric) resultsArray.push(qualifier);
    }

    let results = {
      headerName: " ",
      children: [
      {
        field: 'results',
        headerName: this.gamesService.getGamesHistoryMessages('Results', 'Results'),
        headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
        cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCellClass(this.cvConfigurationService.isCxOne)),
        cellRenderer: (params) => {
          if(this.gs.selectedGame && this.gs.selectedGame[0]?.GameType == GameType.Raffle && params.data.ruleObject) {
            return params.value;
          }
          
          if (typeof params.value === 'undefined')
            return '';

          if (!params.data.participant.AlreadyJoined)
            return params.value;//no results

          if (this.gs.selectedGame && this.gs.selectedGame[0] && this.gs.selectedGame[0].GameType == GameType.Milestone) {
            if (this.gs.selectedGame[0].Qualifier) {
              if (params.data.passed) {
                return '<span class="color-cerulean">' + params.value + '</span>';
              } else {
                return params.value ? params.value : '';
              }
            } else if (params.value) {
              return '<span class="color-cerulean">' + params.value + '</span>';
            }
          } else if (this.gs.selectedGame?.[0]?.GameType == GameType.TopDog) {
            return this.renderTopDogResults(params);
            
          } else if (this.gs.selectedGame && this.gs.selectedGame[0] && this.gs.selectedGame[0].GameType == GameType.Brackets) {
              const span = document.createElement('span');

              span.innerText = params.value;
              span.className = 'color-cerulean cursor-pointer';
              span.addEventListener('click', (event) => this.openExpandedView(event, params));
              return span;
          } else if (this.gs.selectedGame?.[0]?.GameType === GameType.Bullseye && this.cvConfigurationService.isCxOne) {
            const statusClass = connect3AndLevelGamesConnectStatusClass(params.data?.resultsStatus, this.cvConfigurationService.isCxOne);
            return `<span class="${statusClass}">${params.value}</span>`;
          } else {
            return params.value ? params.value : '';
          }
        },
        cellRendererSelector: (params) => {
          const game = this.gs.selectedGame && this.gs.selectedGame.length > 0 ? this.gs.selectedGame[0] : undefined;
          const connectGameType = game.GameType == GameType.Connect3 || game.GameType == GameType.Blackout;
          if (game && connectGameType && params.data?.participant?.LoginID) {
            return {
              component: CvConnect3AllResultRenderComponent,
              params: {
                data: params.data,
                selectedGame: this.gs.selectedGame[0],
                fallbackAbbrevText: this.gamesService.getLocalizedMessage("Metric_Goal", "Metric Goal"),
                getFormattedMetric: this.getFormattedMetric.bind(this),
                isCxOne: this.cvConfigurationService.isCxOne
              }
            }
          }
          return undefined;
        }
      }]
    };

    //if multiplier madness, don't include results column
    if (this.gs.selectedGame.length > 0 && this.gs.selectedGame[0].GameType != 1) {
      resultsArray.push(results);
    }

    const customRewards = (this.gs.selectedGame[0]?.GameType == 9 || this.gs.selectedGame[0]?.GameType == 10) ? [
      {
        field: 'custom',
        headerName: this.gamesService.getGamesHistoryMessages('Custom_Reward', 'Custom Reward'),
        headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
        cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCellClass(this.cvConfigurationService.isCxOne)),
        minWidth: 175,
        cellRenderer: (params) => {
          if (params.value) {
            return params.value;
          }
          return '---';
        },
      }
    ] : [];

    let rewards = {
      headerName: this.cvConfigurationService.isCxOne
        ? this.gamesService.getGamesHistoryMessages('Rewards_Label', 'Rewards')
        : this.gamesService.getGamesHistoryMessages('Reward', 'Reward'),
      headerClass: () => [getHeaderClass(this.cvConfigurationService.isCxOne), getHeaderCenterClass(this.cvConfigurationService.isCxOne)],
      children: [
      {
        field: 'calculatedCoins',
        headerName: this.gamesService.getGamesHistoryMessages('Coins', 'Coins'),
        headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
        cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCellClass(this.cvConfigurationService.isCxOne)),
        filter: 'agNumberColumnFilter',
        cellRenderer: (params) => {
          let isTotalsRow = params.data.participant === undefined;

          if (!isTotalsRow)
            return formatCoin(this.cvConfigurationService.isCxOne, params.value);
          else 
            return this.formatPinnedValue('coin', params.value);
        },
        width: this.cvConfigurationService.isCxOne ? 100 : undefined,
      },
      {
        field: 'calculatedXP',
        headerName: this.gamesService.getGamesHistoryMessages('XP', 'XP'),
        filter: 'agNumberColumnFilter',
        cellRenderer: (params) => {
          let isTotalsRow = params.data.participant === undefined;

          if (!isTotalsRow)
            return params.value;
          else 
            return String(params.value) + this.displayReversionValue(this.revertedXP) + this.gamesService.getGamesHistoryMessages('XP', 'XP');
        },
        hide: this.cvConfigurationService.isCxOne
      },
      {
        field: 'badges',
        headerName: this.cvConfigurationService.isCxOne
          ? this.gamesService.getGamesHistoryMessages('Badge_Label', 'Badge')
          : this.gamesService.getGamesHistoryMessages('Badges', 'Badges'),
        headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
        cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCellClass(this.cvConfigurationService.isCxOne)),
        cellRenderer: (params) => {
          if (typeof params.value === 'undefined')
            return '---';

          if (params.value.length > 0) {
            let badge = `<img src="../Admin/ImageResizer.aspx?imgid=${params.value[0]}&w=${getBadgeSize(this.cvConfigurationService.isCxOne)}&h=${getBadgeSize(this.cvConfigurationService.isCxOne)}" class="img-fluid"/>`;

            /*if (this.gs.selectedGame && this.gs.selectedGame[0] && this.gs.selectedGame[0].GameType == 5 && params.value.length > 1) {
              badge += '<cv-milestone-badges-popover [badges]="data.badges"><span class="color-whaleTail lato-regular font-size-14">' + (params.value.length - 1) + '</span><cv-milestone-badges-popover/>';
            }*/

            return badge;
          } else if (typeof params.value === 'number') {
            //To display in totals row
            return `${this.formatPinnedValue('badge', params.value)} ${this.cvConfigurationService.isCxOne ? '' : this.gamesService.getGamesHistoryMessages('Badges_Awarded', 'Badges Awarded')}`;
          } else {
            return '---'
          }              
        },
        filterParams: {
          cellRenderer: (params) => {
            return params.value;
          }
        },
        sortable: false,
        width: this.cvConfigurationService.isCxOne ? 100 : undefined,
      },
      ...customRewards,
    ]
    };
    resultsArray.push(rewards);

    let payment = {
      headerName: this.gamesService.getGamesHistoryMessages('Payment', 'Payment'),
      headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
      children: [
        {
          field: 'paymentDate',
          headerName: this.cvConfigurationService.isCxOne 
            ? this.gamesService.getGamesHistoryMessages('Payment_Results', 'Payment Results') 
            : this.gamesService.getGamesHistoryMessages('Payment_Info', 'Payment Information'),
          headerClass: getHeaderClass(this.cvConfigurationService.isCxOne),
          cellClass: (params) => getClassIfNotPinned(params.node.rowPinned, getCellClass(this.cvConfigurationService.isCxOne)),
          cellRenderer: (params) => { 
            if(params.data?.custom?.length > 0 && params.data?.productState >= 0){
              const orderStatus = PRODUCT_STATES[params.data.productState] || '---';
              return this.gamesService.getGamesHistoryMessages(orderStatus, orderStatus);
            }

            if (params.node.rowPinned && this.cvConfigurationService.isCxOne) {
              return '';
            }
            
            return formatPaymentInfoValue(params.value, this.cvConfigurationService.isCxOne);
          },
          filterParams: {
            cellRenderer: (params) => { return formatPaymentInfoValue(params.value, this.cvConfigurationService.isCxOne); }
          },
          sortable: true,
        }
      ]
    };

    resultsArray.push(payment);

    return resultsArray;
  }

  // Bracket View
  openExpandedView(event: Event, params: any) {
    event.preventDefault();
    this.currentParticipant = this.gs.selectedGame[0].HistoryEligibility.AssignedGroups.emp.find(x => x.GroupID === params.data.participant.RelatedGroupID);
    this.currentParticipant.RoundNumber = params.data.resultsNumber;
    this.currentParticipant.isWinner = params.data.results === this.gamesService.getLocalizedMessage("Round_1_Final", "Final");
    this.isExpandedView = true;
  }

  closeExpandedView(event: Event) {
    event.preventDefault();
    this.currentParticipant = null;
    this.isExpandedView = false;
  }

  get ruleName() {
    if (!this.hGame) return '';
    return this.hGame.RuleName;
  }

  get selectedMetrics() {
    if (!this.hGame) return [];
    const metric = this.hGame.metricDefinition;
    return [
      {
        ...metric,
        abbrev: metric?.MetricDetail?.Abbrev,
        metricID: metric?.MetricID,
      }
    ]
  }

  /**
   * Function to set the pinned data at the bottom of the grid.
   * @param participants - The participants data to be displayed in the bottom grid.
   */
  setPinnedData(participants: any[]): void {
    const sumPlayers = participants.reduce((sum, current) => sum + 1, 0);
    const sumCoins = participants.filter((a: any) => { return a.calculatedCoins >= 0; }).reduce((sum, current) => sum + current.calculatedCoins, 0);
    const sumXP = participants.filter((a: any) => { return a.calculatedXP >= 0; }).reduce((sum, current) => sum + current.calculatedXP, 0);
    const sumBadges = participants.reduce((sum, current) => sum + current.badges.length, 0);
    const sumCustomRewards = participants.filter((a: { custom?: string, isReverted: boolean }) => a.custom?.length > 0 && !a.isReverted).length;
    const sumRevertCustomRewards = participants.filter((a: { custom?: string, isReverted: boolean }) => a.custom?.length > 0 && a.isReverted).length;
    const revertedCustomRewards = sumRevertCustomRewards > 0 ? `(-${sumRevertCustomRewards})` : '';

    const pinnedData = [{
      participants: this.gamesService.getGamesHistoryMessages('Total_Players', 'Total Players') + ": " + sumPlayers.toLocaleString(CVCultureName),
      calculatedCoins: sumCoins.toLocaleString(CVCultureName),
      calculatedXP: sumXP.toLocaleString(CVCultureName),
      badges: sumBadges,
      custom: `${sumCustomRewards.toLocaleString(CVCultureName)} ${revertedCustomRewards} ${this.gamesService.getGamesHistoryMessages('Custom_Reward', 'Custom Reward')}`,
    }];

    this.agGrid?.api?.setGridOption('pinnedBottomRowData', pinnedData);
  }

  displayReversionValue(value: any): string {
    let resultRev: string = value != 0 ? " (" + formatCoin(this.cvConfigurationService.isCxOne, value) + ") " : " ";
    return resultRev;
  }

  formatPinnedValue(columnName: 'coin' | 'badge', value: number): string {
    const getLabel = (key: string, fallback: string) => this.gamesService.getGamesHistoryMessages(key, fallback);

    switch (columnName) {
      case 'coin': {
        const coinValue = formatCoin(this.cvConfigurationService.isCxOne, value);
        const reversion = this.displayReversionValue(this.revertedCoins);
        const label = this.cvConfigurationService.isCxOne ? '' : ` ${getLabel('Coins', 'Coins')}`;
        return `${coinValue}${reversion}${label}`;
      }
      case 'badge': {
        const badgeValue = value ?? 0;
        const formattedBadgeValue = badgeValue.toLocaleString(CVCultureName);
        return this.cvConfigurationService.isCxOne ? `${badgeValue === 0 ? '---' : formattedBadgeValue}` : `${formattedBadgeValue}`;
      }
      default:
        return '';
    }
  }

  getFormattedMetric(value, format): string {
    return this.metricFormatPipe.transform(value, format);
  }

  private renderTopDogResults(params: any): string {
    if (this.cvConfigurationService.isCxOne && params.value && /^\d+(st|nd|rd|th) Place$/.test(params.value)) {
      return `<span class="player-breakdown__grid-connect-status">${params.value}</span>`;
    } else {
      return params.value ?? '';
    }
  }

  private resizeColumns = debounce((event) => {
    event.api.sizeColumnsToFit();
  }, 50);

  handleResizeOnGameOrGroupChange(e: GridSizeChangedEvent): void {
    const currentGameType = this.gs.selectedGame[0]?.GameType;
    const currentGame = this.hGame?.RuleID;

    // For Connect3 and ConnectAll, only resize if the game changed or the column group is not expanded
    if (currentGameType === GameType.Connect3 || currentGameType === GameType.Blackout) {
      const metricTotalGroup = this.gridApi.getColumnGroup('metricTotalsGroup');
      const isExpanded = metricTotalGroup?.isExpanded();
      // If the previous game is the same as the current and the column group is expanded, do not resize
      if (this.previousGame !== currentGame && isExpanded) {
        e.api.autoSizeAllColumns();
      }

      // If the column group is closed, always size columns to fit (regardless of game change)
      if (!isExpanded) {
        e.api.sizeColumnsToFit();
      }
      return;
    }

    // For other game types, always resize columns
    e.api.sizeColumnsToFit();
  }
}
